import { sha256 } from 'js-sha256';

import { CurrencyCode } from '@/__generated__/storefront/graphql';

type FeatureName = 'pattern_product_suggestions' | 'product_review';

export type UserEventDefinitions = {
  generic_user_event: {
    action: string;
    category: string;
    label?: string;
    value?: string | number;
    [key: string]: unknown;
  };
  download_pattern: {
    action: 'download_pattern';
    category: 'plus_pattern' | 'free_pattern';
    label: string;
    item_id: string | number;
  };
  pattern_products_add_to_cart: {
    action: 'pattern_products_add_to_cart';
    category: string;
    label?: string;
    currency: CurrencyCode;
    items: {
      item_id: string;
      item_name?: string;
      item_category?: string;
      item_variant?: string;
      price: number;
      quantity?: number;
    }[];
    value: number;
  };
  pattern_products_add_all_to_cart: {
    action: 'pattern_products_add_all_to_cart';
    category: 'all_recommendations';
    label?: string;
    currency: CurrencyCode;
    items: {
      item_id: string;
      item_name?: string;
      item_category?: string;
      item_variant?: string;
      price: number;
      quantity?: number;
    }[];
    value: number;
  };
  feature_view: {
    action: 'feature_view';
    category: 'section' | 'modal';
    item_name: FeatureName;
    label: string;
  };
  add_review: {
    action: 'add_review';
    category: 'Product Review';
    item_id: string;
    item_name: string;
    label: string;
    value: number;
  };
  show_original_review: {
    action: 'show_original_review';
    category: 'Product Review';
    item_id: string;
    item_name: string;
    label: string;
    value: number;
  };
};

type EventNames = keyof UserEventDefinitions;

type TrackUserEvent = <T extends EventNames>(
  event: T,
  data: UserEventDefinitions[T]
) => void;

export const trackUserEvent: TrackUserEvent = (eventName, data) => {
  window.dataLayer?.push({
    // We need to use generic_user_event for all new events except download_pattern, to avoid configuring GTM for every new type of event
    event: eventName === 'download_pattern' ? eventName : 'generic_user_event',
    user_event_data: data
  });
};

// We use the algorithm sha256 for encoding according to Meta Pixel documentation
// https://developers.facebook.com/docs/meta-pixel/advanced/advanced-matching/
// https://developers.google.com/google-ads/api/docs/conversions/enhanced-conversions/web#prepare-data
export const hashUserData = (value: string) => {
  return sha256(value);
};
